import React, { Component } from "react";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import Divider from "@material-ui/core/Divider";
import Button from "@material-ui/core/Button";
import FormGroup from "@material-ui/core/FormGroup";
import Tooltip from "@material-ui/core/Tooltip";
import FormControl from "@material-ui/core/FormControl";
import NativeSelect from "@material-ui/core/NativeSelect";
import Input from "@material-ui/core/Input";
import TablePagination from "@material-ui/core/TablePagination";
import DatePicker from "react-datepicker";
import Radio from "@material-ui/core/Radio";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import ArrowDropUp from "@material-ui/icons/ArrowDropUp";
import IconButton from "@material-ui/core/IconButton";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";

import { withStyles } from "@material-ui/core/styles";
import { withTranslation } from "react-i18next";
import {
  ROWS_PER_PAGE_OPTIONS,
  BACKEND_DATE_FORMAT,
} from "../components/Constants";
import { getErrorString } from "../display/ErrorStrings";
import PopupMessage from "../components/PopupMessage";
import ViewPdf from "../components/ViewPdf";
import CustomPaginatorActions from "../components/CustomPaginatorActions";

import downloadjs from "downloadjs";

import SearchIcon from "@material-ui/icons/PageviewOutlined";
import PDFViewIcon from "@material-ui/icons/BookOutlined";
import DownloadIcon from "@material-ui/icons/AssignmentReturnedOutlined";
import PrintIcon from "@material-ui/icons/PrintOutlined";
import DownloadARPIcon from "@material-ui/icons/AirplayOutlined";

import { Portal } from "react-overlays";

const CalendarContainer = ({ children }) => {
  const el = document.getElementById("calendar-portal");

  return <Portal container={el}>{children}</Portal>;
};

const styles = (theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },

  boldCell: {
    fontWeight: "bold",
    fontSize: 14,
  },
  table: {
    border: "1px solid black",
    margin: "20px",
    width: 700,
  },

  table1: {
    margin: "20px",
  },

  table2: {
    border: "1px solid black",
    margin: "20px",
    width: 1000,
  },

  table3: {
    marginLeft: "20px",
    marginTop: "0px",
    width: 1000,
  },
});

const reportOptons = [
  { id: "1", label: "Depository Summary" },
  { id: "2", label: "Depository Detail" },
  { id: "3", label: "Intra-day Reconciliation Summary" },
  { id: "4", label: "Reconciliation Summary" },
  { id: "5", label: "Reconciliation Detail" },
];

class AccountReconciliationPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      errorString: "",
      notifyString: "",
      items: [],
      totalAmount: "",
      order: "asc",
      orderBy: "6",
      page: 0,
      rowsPerPage: window.sco_large_items_per_page,
      totalCount: 0,
      canSearch: false,
      selectedOption: "1",
      selectedTransCode: 0,
      startDate: null,
      redrawStartDate: false,
      redrawEndDate: false,
      endDate: null,
      backendStartDate: "",
      backendEndDate: "",
      waitingDownload: false,
      validated: false,
      viewPdf: false,
      radioValue: "B",
      arpValue: "",
      collapsedSearch: false,
      replyObject: {},
      reportItems: [],
      viewPopup: false,
      selectedSort: "1",      	  	  
    };
    this.onClosePopup = this.onClosePopup.bind(this);
  }

  handleSort(e) {
    this.setState({ selectedSort: e.target.value });
    if (e.target.value === "1") {
      this.setState({ orderBy: "6" });
    }          
    if (e.target.value === "2") {
      this.setState({ orderBy: "5" });
    }
    if (e.target.value === "3") {
      this.setState({ orderBy: "0" });
    }	
  }
  
  handleChange(e) {
    e.preventDefault();
    this.props.onReportChange(e);
  }

  handleOptionChange(e) {
    e.preventDefault();
    this.disableSearch();
    this.setState({ selectedOption: e.target.value });
  }

  handleRadioChange = (event) => {
    this.disableSearch();
    this.setState({ radioValue: event.target.value });
  };

  handleTransCode(event) {
    this.disableSearch();
    this.setState({ selectedTransCode: event.target.value });
  }

  handleArpFormat(event) {
    this.disableSearch();
    this.setState({ arpValue: event.target.value });
  }
  componentDidMount() {
    if (this.props.arpFormats.length > 0) {
      this.setState({ arpValue: this.props.arpFormats[0] });
    }
  }

  componentDidUpdate() {
    if (this.state.redrawStartDate) {
      this.setState({ redrawStartDate: false });
    }
    if (this.state.redrawEndDate) {
      this.setState({ redrawEndDate: false });
    }
    if (this.state.waitingDownload && this.state.validated) {
      this.setState({ validated: false });
      this.setState({ waitingDownload: false });
    }
  }

  disableSearch() {
    this.setState({ canSearch: false });
    this.setState({ totalCount: 0 });
    this.setState({ page: 0 });
  }

  handleSearch(e) {
    if (this.state.selectedOption !== "3" && !this.validateDates()) {
      return;
    }
    this.setState({ canSearch: true });
    this.search(this.getSearchObject(this.state.page, this.state.rowsPerPage));
  }

  validateDates() {
    let start = this.state.startDate;
    let end = this.state.endDate;
    if (start !== null && end !== null && end.isBefore(start, "day")) {
      this.setState({
        errorString: getErrorString(
          "general.error.endDate",
          "End Date is before Start Date"
        ),
      });
      this.setState({ viewPopup: true });
      return false;
    }
    return true;
  }
  handlePdf(e) {
    if (this.state.selectedOption !== "3" && !this.validateDates()) {
      return;
    }
    this.setState({ viewPdf: true });
  }

  handlePrint(e) {
    var prtContent = document.getElementById("myReport");
    var winPrint = window.open(
      "",
      "",
      "left=0,top=0,width=800,height=600,toolbar=0,scrollbars=0,status=0"
    );
    winPrint.document.write(prtContent.innerHTML);
    winPrint.document.close();
    winPrint.focus();
    winPrint.print();
    winPrint.close();
  }

  handleDownload(e) {
    if (this.state.selectedOption !== "3" && !this.validateDates()) {
      return;
    }
    //	    this.setState({ waitingDownload: true });
    //		this.setState({ validated: false});
    this.downloadFile(
      this.getSearchObject(this.state.page, this.state.rowsPerPage),
      "on_recon_bai2_download",
      "bai2.zip"
    );
  }

  handleDownloadArp(e) {
    if (this.state.selectedOption !== "3" && !this.validateDates()) {
      return;
    }
    //	    this.setState({ waitingDownload: true });
    //		this.setState({ validated: false});
    //	    let myUrl = this.getUrl('on_search_paid_items_request', this.state.rowsPerPage, this.state.page, this.state.order, this.state.orderBy, true);
    this.downloadFile(
      this.getSearchObject(this.state.page, this.state.rowsPerPage),
      "on_recon_arp_download",
      "arp.zip"
    );
  }

  downloadFile(searchData, myUrl, fileName) {
    fetch(myUrl, {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(searchData),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.blob())
      .then((blob) => {
        downloadjs(blob, fileName, "application/zip");
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ viewPopup: true });
      });
  }

  handleCollapse = (event) => {
    this.setState({ collapsedSearch: !this.state.collapsedSearch });
  };

  handleRadioChange = (event) => {
    this.disableSearch();
    this.setState({ radioValue: event.target.value });
  };

  handleStartDate(date) {
    this.disableSearch();
    this.setState({ startDate: date });
    if (date === null) {
      this.setState({ backendStartDate: "" });
    } else {
      this.setState({ backendStartDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleStartDateOutsideClick(e) {
    this.setState({ redrawStartDate: true });
  }

  handleEndDate(date) {
    this.disableSearch();
    this.setState({ endDate: date });
    if (date === null) {
      this.setState({ backendEndDate: "" });
    } else {
      this.setState({ backendEndDate: date.format(BACKEND_DATE_FORMAT) });
    }
  }

  handleEndDateOutsideClick(e) {
    this.setState({ redrawEndDate: true });
  }

  handleChangeRowsPerPage(e) {
    this.setState({ rowsPerPage: e.target.value });
    this.setState({ page: 0 });
    window.sco_large_items_per_page = e.target.value;
    if (this.state.canSearch) {
      this.search(this.getSearchObject(0, e.target.value));
    }
  }

  handleChangePage = (event, page) => {
    this.setState({ page: page });
    if (this.state.canSearch) {
      this.search(this.getSearchObject(page, this.state.rowsPerPage));
    }
  };

  handleRequestSort = (event, property) => {
    if (property.indexOf("nosort") !== -1) {
      return;
    }
    const orderBy = property;
    let order = "desc";
    if (this.state.orderBy === property) {
      if (this.state.order === "desc") {
        order = "asc";
      }
    } else {
      order = this.state.order;
    }
    this.setState({ order, orderBy });
    let myUrl = this.getUrl(
      "on_search_paid_items_request",
      this.state.rowsPerPage,
      this.state.page,
      order,
      orderBy,
      false
    );
    this.search(myUrl, false);
  };

  onClosePopup(e) {
    this.setState({ viewPopup: false });
    this.setState({ viewPdf: false });
    this.setState({ waitingDownload: false });
    this.setState({ errorString: "" });
    this.setState({ notifyString: "" });
  }

  search(searchData) {
    fetch(this.getSearchControllerName(), {
      method: "POST",
      credentials: "same-origin",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify(searchData),
    })
      .then(function (res) {
        if (!res.ok) {
          throw Error(res.status + " (" + res.statusText + ")");
        }
        return res;
      })
      .then((res) => res.text())
      .then((text) => {
        var reply = JSON.parse(text);
        if (!reply.authenticated) {
          this.props.history.push("/expired");
        } else if (reply.error) {
          this.setState({ errorString: reply.errorString });
          this.setState({ viewPopup: true });
          this.setState({ totalCount: 0 });
        } else {
          this.setState({ totalCount: reply.totalCount });
          this.setState({ replyObject: reply });
          if (
            this.state.selectedOption !== "3" &&
            this.state.selectedOption !== "4"
          ) {
            this.setState({ reportItems: reply.items });
          }
          if (reply.totalCount === 0) {
            this.setState({ viewPopup: true });
            this.setState({
              notifyString: getErrorString(
                "general.info.search.empty",
                "Total number of items is 0."
              ),
            });
          }
        }
      })
      .catch((error) => {
        this.setState({
          errorString:
            getErrorString(
              "general.server.status.error",
              "The server responded with a status of "
            ) + error.message,
        });
        this.setState({ totalCount: 0 });
        this.setState({ viewPopup: true });
      });
  }

  getPdfControllerName() {
    if (this.state.selectedOption === "1") {
      return "on_depository_summary_pdf_request";
    } else if (this.state.selectedOption === "2") {
      return "on_depository_detail_pdf_request";
    } else if (this.state.selectedOption === "3") {
      return "on_recon_intraday_pdf_search";
    } else if (this.state.selectedOption === "4") {
      return "on_recon_summary_pdf_search";
    } else if (this.state.selectedOption === "5") {
      return "on_recon_details_pdf_request";
    } else {
      return "";
    }
  }

  getSearchControllerName() {
    if (this.state.selectedOption === "1") {
      return "on_depository_summary";
    } else if (this.state.selectedOption === "2") {
      return "on_depository_detail";
    } else if (this.state.selectedOption === "3") {
      return "on_recon_intraday_search";
    } else if (this.state.selectedOption === "4") {
      return "on_recon_summary_search";
    } else if (this.state.selectedOption === "5") {
      return "on_recon_details_search";
    } else {
      return "";
    }
  }

  getSearchObject(page, rowsPerPage) {
    let data = {
      transit: this.props.accountObject.transit,
      account: this.props.accountObject.account,
      startDate: this.state.backendStartDate,
      endDate: this.state.backendEndDate,
      page: page,
      rowsPerPage: rowsPerPage,
      crDr: this.state.radioValue,
      transactionCode: this.props.transCodes[this.state.selectedTransCode].id,
      arpFormat: this.state.arpValue,
      secureToken: this.props.secureToken,
    };
    return data;
  }

  render() {
    const { rowsPerPage, page, totalCount } = this.state;
    const { classes } = this.props;
    const datePickerTopMargin = 8;
    const actionTopMargin = 16;
    let options = this.props.reports;
    let transCodes = this.props.transCodes;
    let arpFormats = this.props.arpFormats;
    let report = this.state.replyObject;
    let items = this.state.reportItems;
    let { t } = this.props;
    return (
      <div>
        {this.state.viewPdf && (
          <ViewPdf
            history={this.props.history}
            secureToken={this.props.secureToken}
            onClosePopup={this.onClosePopup}
            page={page}
            rowsPerPage={rowsPerPage}
            postData={this.getSearchObject(page, rowsPerPage)}
            pdfUrl={this.getPdfControllerName()}
          />
        )}
        {this.state.viewPopup && this.state.errorString.length > 0 && (
          <PopupMessage
            title="Error"
            text={this.state.errorString}
            error={true}
            onClosePopup={this.onClosePopup}
          />
        )}
        {this.state.viewPopup && this.state.notifyString.length > 0 && (
          <PopupMessage
            title={getErrorString("general.info.title", "Information")}
            text={this.state.notifyString}
            error={false}
            onClosePopup={this.onClosePopup}
          />
        )}

        <div>
          <div>
            <Paper elevation={3}>
              <FormGroup row>
                <div>
                  <Typography variant="caption">
                    {t("report.label")}&nbsp;&nbsp;
                  </Typography>
                  <FormControl>
                    <NativeSelect
                      style={{
                        height: 48,
                        verticalAlign: "textTop",
                        margin: 0,
                      }}
                      defaultValue={this.props.option.index}
                      input={<Input id="report_options" />}
                      onChange={(event) => this.handleChange(event)}
                    >
                      {options.map((n) => {
                        return <option value={n.index}>{n.description}</option>;
                      })}
                    </NativeSelect>
                  </FormControl>
                  &nbsp;&nbsp;
                </div>
                <div>
                  <Typography variant="caption">
                    {t("reportOption.label")}&nbsp;&nbsp;
                  </Typography>
                  <FormControl>
                    <NativeSelect
                      style={{
                        height: 48,
                        verticalAlign: "textTop",
                        margin: 0,
                      }}
                      defaultValue="0"
                      input={<Input id="options" />}
                      onChange={(event) => this.handleOptionChange(event)}
                    >
                      {reportOptons.map((n) => {
                        return <option value={n.id}>{n.label}</option>;
                      })}
                    </NativeSelect>
                  </FormControl>
                  &nbsp;&nbsp;
                </div>
				<div>
				 <Typography variant="caption">
				   {t("sort.label")}&nbsp;&nbsp;
				 </Typography>
				 <FormControl>
				   <NativeSelect
					  style={{ height: 48, verticalAlign: "textTop", margin: 0 }}
					  defaultValue={this.state.selectedSort}
					  input={<Input id="sort_options" />}
					  onChange={(event) => this.handleSort(event)}
					>                      
					  <option value="1">{t("amount.label")}</option>
					  <option value="2">{t("payee.label")}</option>
					  <option value="3">{t("default.label")}</option>
					</NativeSelect>
				 </FormControl>
				 &nbsp;&nbsp;
				</div>                    					
				<Tooltip
                  title={
                    t("showSearchResult.tip") + this.props.option.description
                  }
                >
                  <Button
                    color="primary"
                    style={{ marginTop: actionTopMargin }}
                    onClick={(event) => this.handleSearch(event)}
                  >
                    <SearchIcon />
                    &nbsp;{t("search.button")}
                  </Button>
                </Tooltip>
                <Tooltip title={t("viewPdfReport.tip")}>
                  <Button
                    color="primary"
                    style={{ marginTop: actionTopMargin }}
                    onClick={(event) => this.handlePdf(event)}
                  >
                    <PDFViewIcon />
                    &nbsp;{t("pdf.button")}
                  </Button>
                </Tooltip>
                <Tooltip title={t("downLoadBai2.tip")}>
                  <Button
                    color="primary"
                    style={{ marginTop: actionTopMargin }}
                    onClick={(event) => this.handleDownload(event)}
                  >
                    <DownloadIcon />
                    &nbsp;{t("download.button")}
                  </Button>
                </Tooltip>
                {this.state.canSearch &&
                  this.state.totalCount !== 0 &&
                  this.state.errorString.length === 0 &&
                  this.state.notifyString.length === 0 && (
                    <Tooltip title={t("printReport.tip")}>
                      <Button
                        color="primary"
                        style={{ marginTop: actionTopMargin }}
                        onClick={(event) => this.handlePrint(event)}
                      >
                        <PrintIcon />
                        &nbsp;{t("print.button")}
                      </Button>
                    </Tooltip>
                  )}

                {!this.state.collapsedSearch && arpFormats.length > 0 && (
                  <div>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <Typography variant="caption">
                      {t("arpFormat.label")}
                    </Typography>
                    &nbsp;&nbsp;
                    <FormControl>
                      <NativeSelect
                        style={{
                          height: 28,
                          verticalAlign: "textTop",
                          margin: 0,
                        }}
                        defaultValue={this.state.arpValue}
                        input={<Input id="arp_format" />}
                        onChange={(event) => this.handleArpFormat(event)}
                      >
                        {arpFormats.map((n) => {
                          return <option value={n}>{n}</option>;
                        })}
                      </NativeSelect>
                    </FormControl>
                    &nbsp;&nbsp;
                    <Button
                      color="primary"
                      style={{ marginTop: actionTopMargin }}
                      onClick={(event) => this.handleDownloadArp(event)}
                    >
                      <DownloadARPIcon />
                      &nbsp;{t("downloadArp.button")}
                    </Button>
                  </div>
                )}

                {!this.state.collapsedSearch && (
                  <Tooltip title={t("collaspSearch.tip")}>
                    <IconButton
                      style={{ position: "absolute", right: 10, top: 0 }}
                      onClick={(event) => this.handleCollapse(event)}
                    >
                      <ArrowDropUp />
                    </IconButton>
                  </Tooltip>
                )}
                {this.state.collapsedSearch && (
                  <Tooltip title={t("expandSearch.tip")}>
                    <IconButton
                      style={{ position: "absolute", right: 10, top: 0 }}
                      onClick={(event) => this.handleCollapse(event)}
                    >
                      <ArrowDropDown />
                    </IconButton>
                  </Tooltip>
                )}
              </FormGroup>

              {!this.state.collapsedSearch &&
                this.state.selectedOption !== "3" && (
                  <FormGroup row>
                    <div>
                      <Typography variant="caption">
                        {t("startDate.label")}
                        {!this.state.redrawStartDate && (
                          <div style={{ marginTop: datePickerTopMargin }}>
                            <DatePicker
                              isClearable
                              disabledKeyboardNavigation
                              dateFormat="LL"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={this.state.startDate}
                              onChange={(event) => this.handleStartDate(event)}
                              onClickOutside={(event) =>
                                this.handleStartDateOutsideClick(event)
                              }
                              popperContainer={CalendarContainer}
                            />
                          </div>
                        )}
                      </Typography>
                    </div>
                    &nbsp;&nbsp;
                    <div>
                      <Typography variant="caption">
                        {t("endDate.label")}
                        {!this.state.redrawEndDate && (
                          <div style={{ marginTop: datePickerTopMargin }}>
                            <DatePicker
                              isClearable
                              disabledKeyboardNavigation
                              dateFormat="LL"
                              showMonthDropdown
                              showYearDropdown
                              dropdownMode="select"
                              selected={this.state.endDate}
                              onChange={(event) => this.handleEndDate(event)}
                              onClickOutside={(event) =>
                                this.handleEndDateOutsideClick(event)
                              }
                              popperContainer={CalendarContainer}
                            />
                          </div>
                        )}
                      </Typography>
                    </div>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    {this.state.selectedOption !== "4" && (
                      <div>
                        <Typography variant="caption">
                          {t("transactionCode.label")}&nbsp;&nbsp;
                        </Typography>
                        <FormControl>
                          <NativeSelect
                            style={{
                              height: 48,
                              verticalAlign: "textTop",
                              margin: 0,
                            }}
                            defaultValue={this.state.selectedTransCode}
                            input={<Input id="trans_code" />}
                            onChange={(event) => this.handleTransCode(event)}
                          >
                            {transCodes.map((n) => {
                              return (
                                <option
                                  value={n.index}
                                  title={
                                    n.index === 0
                                      ? ""
                                      : n.ach
                                      ? "ACH Transaction Code"
                                      : "Check Transaction Code"
                                  }
                                >
                                  {n.descr}
                                </option>
                              );
                            })}
                          </NativeSelect>
                        </FormControl>
                        &nbsp;&nbsp;
                      </div>
                    )}
                    {this.state.selectedOption === "5" && (
                      <div style={{ marginTop: datePickerTopMargin }}>
                        &nbsp;&nbsp;&nbsp;&nbsp;
                        <FormControlLabel
                          value="C"
                          control={
                            <Radio
                              color="default"
                              checked={this.state.radioValue === "C"}
                              onChange={this.handleRadioChange}
                              value="C"
                              name="radioButton"
                            />
                          }
                          label={t("credit.label")}
                        />
                        <FormControlLabel
                          value="V"
                          control={
                            <Radio
                              color="default"
                              checked={this.state.radioValue === "D"}
                              onChange={this.handleRadioChange}
                              value="D"
                              name="radioButton"
                            />
                          }
                          label={t("debit.label")}
                        />
                        <FormControlLabel
                          value="B"
                          control={
                            <Radio
                              color="default"
                              checked={this.state.radioValue === "B"}
                              onChange={this.handleRadioChange}
                              value="B"
                              name="radioButton"
                            />
                          }
                          label={t("both.label")}
                        />
                      </div>
                    )}
                  </FormGroup>
                )}
            </Paper>
          </div>
          <Divider />
          {this.state.selectedOption !== "3" &&
            this.state.selectedOption !== "4" && (
              <TablePagination
                component="div"
                count={totalCount}
                rowsPerPage={rowsPerPage}
                rowsPerPageOptions={ROWS_PER_PAGE_OPTIONS}
                page={page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={(event) =>
                  this.handleChangeRowsPerPage(event)
                }
                ActionsComponent={CustomPaginatorActions}
              />
            )}
          <div id="myReport">
            {this.state.canSearch &&
              this.state.totalCount !== 0 &&
              this.state.errorString.length === 0 &&
              this.state.notifyString.length === 0 &&
              this.state.selectedOption === "1" && (
                <div>
                  <div style={{ marginTop: 30, marginLeft: 20 }}>
                    <Typography variant="headline">
                      &nbsp;{report.companyName} &nbsp;
                      {t("depositoryAccount.label")}
                    </Typography>
                  </div>
                  <table className={classes.table1}>
                    <Paper elevation={6}>
                      <tr>
                        <td>
                          {" "}
                          <strong>&nbsp;{t("reportDate.label")}</strong>
                        </td>
                        <td> {report.dateCreated}</td>
                        <td colSpan={2}>
                          {" "}
                          <strong>&nbsp;{t("createdBy.label")}</strong>{" "}
                          &nbsp;&nbsp;&nbsp;{report.userName}
                        </td>
                      </tr>
                      <br />
                      <tr>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("transit.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("account.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;<strong>{t("from.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;<strong>{t("to.header")}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          &nbsp;&nbsp;&nbsp;{this.props.accountObject.transit}
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;{this.props.accountObject.account}
                        </td>
                        <td>&nbsp;&nbsp;&nbsp;{report.startDate}</td>
                        <td>&nbsp;&nbsp;&nbsp;{report.endDate}</td>
                      </tr>
                    </Paper>
                  </table>
                  <div style={{ marginTop: 20, marginLeft: 20 }}>
                    <Typography variant="h6">
                      &nbsp;{t("depositSummary.label")}
                    </Typography>
                  </div>

                  <table className={classes.table}>
                    <TableHead>
                      <tr>
                        <td style={{ width: "100px" }}>
                          <strong>{t("serial.header")}</strong>
                        </td>
                        <td style={{ width: "200px" }}>
                          <strong>{t("location.header")}</strong>
                        </td>
                        <td style={{ width: "120px" }}>
                          <strong>{t("debitCredit.header")}</strong>
                        </td>
                        <td style={{ width: "120px" }}>
                          <strong>{t("count.header")}</strong>
                        </td>
                        <td style={{ width: "160px" }}>
                          <strong>{t("amount.header")}</strong>
                        </td>
                      </tr>
                    </TableHead>
                    <TableBody>
                      {items.map((item) => {
                        return (
                          <tr>
                            {item.type === "D" && (
                              <td rowSpan={3}>{item.serial} </td>
                            )}
                            {item.type === "D" && (
                              <td rowSpan={3}>{item.locationName} </td>
                            )}
                            {item.type === "S" && (
                              <td>
                                <strong>{t("subTotal.label")}</strong>
                              </td>
                            )}
                            {item.type === "D" && <td>{t("debit.label")}</td>}
                            {item.type === "C" && <td>{t("credit.label")}</td>}
                            {item.type === "S" && (
                              <td>
                                <strong>{item.count}</strong>
                              </td>
                            )}
                            {item.type !== "S" && <td> {item.count}</td>}
                            {item.type === "S" && (
                              <td>
                                <strong>{item.amount}</strong>
                              </td>
                            )}
                            {item.type !== "S" && <td> {item.amount}</td>}
                          </tr>
                        );
                      })}
                      <tr style={{ height: "20px" }}></tr>
                      <tr>
                        <td colSpan={2}>
                          <strong>
                            {" "}
                            &nbsp;{t("totalItems.label")}: {report.itemCount}{" "}
                          </strong>
                        </td>
                        <td colSpan={2}>
                          <strong>
                            {" "}
                            &nbsp;{t("totalAmount.label")}: {report.totalAmount}{" "}
                          </strong>
                        </td>
                      </tr>
                    </TableBody>
                  </table>
                </div>
              )}

            {this.state.canSearch &&
              this.state.totalCount !== 0 &&
              this.state.errorString.length === 0 &&
              this.state.notifyString.length === 0 &&
              this.state.selectedOption === "2" && (
                <div>
                  <div style={{ marginTop: 30, marginLeft: 20 }}>
                    <Typography variant="headline">
                      &nbsp;{report.companyName} &nbsp;
                      {t("depositoryAccount.label")}{" "}
                    </Typography>
                  </div>
                  <table className={classes.table1}>
                    <Paper elevation={6}>
                      <tr>
                        <td>
                          {" "}
                          <strong>&nbsp;{t("reportDate.label")}</strong>
                        </td>
                        <td> {report.dateCreated}</td>
                        <td colSpan={2}>
                          {" "}
                          <strong>&nbsp;{t("createdBy.label")}</strong>{" "}
                          &nbsp;&nbsp;&nbsp;{report.userName}
                        </td>
                      </tr>
                      <br />
                      <tr>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("transit.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("account.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;<strong>{t("from.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;<strong>{t("to.header")}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          &nbsp;&nbsp;&nbsp;{this.props.accountObject.transit}
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;{this.props.accountObject.account}
                        </td>
                        <td>&nbsp;&nbsp;&nbsp;{report.startDate}</td>
                        <td>&nbsp;&nbsp;&nbsp;{report.endDate}</td>
                      </tr>
                    </Paper>
                  </table>
                  <div style={{ marginTop: 20, marginLeft: 20 }}>
                    <Typography variant="h6">
                      &nbsp;{t("depositDetail.label")}
                    </Typography>
                  </div>

                  <table className={classes.table}>
                    <TableHead>
                      <tr>
                        <td style={{ width: "100px" }}>
                          <strong>{t("serial.header")}</strong>
                        </td>
                        <td style={{ width: "200px" }}>
                          <strong>{t("location.header")}</strong>
                        </td>
                        <td style={{ width: "160px" }}>
                          <strong>{t("amount.header")}</strong>
                        </td>
                        <td style={{ width: "160px" }}>
                          <strong>{t("transactionDate.header")}</strong>
                        </td>
                      </tr>
                    </TableHead>
                    <TableBody>
                      {items.map((item) => {
                        return (
                          <tr>
                            {item.type === "C" && (
                              <td rowSpan={parseInt(item.count, 10)}>
                                {item.serial}{" "}
                              </td>
                            )}
                            {item.type === "C" && (
                              <td td rowSpan={parseInt(item.count, 10)}>
                                {item.locationName}{" "}
                              </td>
                            )}
                            {(item.type === "C" || item.type.length === 0) && (
                              <td>{item.amount}</td>
                            )}
                            {(item.type === "C" || item.type.length === 0) && (
                              <td>{item.itemDate}</td>
                            )}
                            {item.type === "S" && <td></td>}
                            {item.type === "S" && (
                              <td>
                                <strong>{t("subTotal.label")}</strong>
                              </td>
                            )}
                            {item.type === "S" && (
                              <td>
                                {" "}
                                <strong>{item.amount}</strong>
                              </td>
                            )}
                            {item.type === "S" && (
                              <td>
                                <strong>{"Items: " + item.count}</strong>
                              </td>
                            )}
                          </tr>
                        );
                      })}
                      <tr style={{ height: "20px" }}></tr>
                      <tr>
                        <td colSpan={2}>
                          <strong>
                            {" "}
                            &nbsp;{t("totalRecord.label")}: {report.itemCount}{" "}
                          </strong>
                        </td>
                      </tr>
                    </TableBody>
                  </table>
                </div>
              )}

            {this.state.canSearch &&
              this.state.totalCount !== 0 &&
              this.state.errorString.length === 0 &&
              this.state.notifyString.length === 0 &&
              this.state.selectedOption === "3" && (
                <div>
                  <div style={{ marginTop: 30, marginLeft: 20 }}>
                    <Typography variant="headline">
                      &nbsp;{t("intradayReconci.label")}
                    </Typography>
                  </div>
                  <table className={classes.table1}>
                    <Paper elevation={6}>
                      <tr>
                        <td>
                          {" "}
                          <strong>&nbsp;{t("reportDate.label")}</strong>
                        </td>
                        <td> {report.dateCreated}</td>
                        <td colSpan={2}>
                          {" "}
                          <strong>&nbsp;{t("createdBy.label")}</strong>{" "}
                          &nbsp;&nbsp;&nbsp;{report.userName}
                        </td>
                      </tr>
                      <br />
                      <tr>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("companyName.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("transit.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("account.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("reconci.header")}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>&nbsp;&nbsp;&nbsp;{report.companyName}</td>
                        <td>
                          &nbsp;&nbsp;&nbsp;{this.props.accountObject.transit}
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;{this.props.accountObject.account}
                        </td>
                        <td>&nbsp;&nbsp;&nbsp;{report.startDate}</td>
                      </tr>
                    </Paper>
                  </table>
                  <div style={{ marginTop: 20, marginLeft: 20 }}>
                    <Typography variant="h6">
                      &nbsp;{t("checkAccountSummary.label")}
                    </Typography>
                  </div>
                  <table className={classes.table2}>
                    <tr>
                      <td style={{ width: "400px" }}>
                        {t("balanceForward.label")}
                      </td>
                      <td style={{ width: "300px" }}></td>
                      <td style={{ width: "160px" }}></td>
                      <td align="right" style={{ width: "160px" }}>
                        {report.stBalance}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {t("addTotalCredit.label")} ({report.numCredits})
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.credits}</td>
                    </tr>
                    <tr>
                      <td>{t("deductTotal.label")}:</td>
                      <td>
                        {t("checkPaid.label")} ({report.numChkPaid1})
                      </td>
                      <td align="right">{report.chkPaid1}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("misDebit.label")} ({report.numMisDebits})
                      </td>
                      <td align="right">
                        <u>{report.misDebits}</u>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        {t("totalDebits.label")} ({report.numTotDebits})
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.totDebits}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>{t("currentBalance.label")}</strong>
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">
                        <strong>{report.curBalance}</strong>
                      </td>
                    </tr>
                  </table>
                  <div style={{ marginTop: 20, marginLeft: 20 }}>
                    <Typography variant="h6">
                      &nbsp;{t("accountReconciSummary.label")}
                    </Typography>
                  </div>
                  <table className={classes.table2}>
                    <tr>
                      <td style={{ width: "400px" }}>
                        {t("previousOutstanding.label")}
                      </td>
                      <td style={{ width: "300px" }}></td>
                      <td style={{ width: "160px" }}></td>
                      <td align="right" style={{ width: "160px" }}>
                        {report.preOutstanding}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("addTotal.label")}:</td>
                      <td>
                        {t("newIssue.label")}({report.numNewIssue})
                      </td>
                      <td align="right">{report.newIssue}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("paidNotIssued.label")} ({report.numPni})
                      </td>
                      <td align="right">{report.pni}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("stopRemove.label")} ({report.numStopRem})
                      </td>
                      <td align="right">{report.stopRem}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        {" "}
                        {t("additionsTo.label")} ({report.numAddOuts})
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.addOutstanding}</td>
                    </tr>
                    <tr>
                      <td> {t("deductTotal.label")}:</td>
                      <td>
                        {t("totalCheckPaid.label")} ({report.numChkPaid2})
                      </td>
                      <td align="right">{report.chkPaid2}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("stopPlaced.label")}({report.numStopPlace})
                      </td>
                      <td align="right">{report.stopPlace}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("issuesCancel.label")} ({report.numCancelled})
                      </td>
                      <td align="right">{report.cancelled}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("otherException.label")}({report.numOexc})
                      </td>
                      <td align="right">{report.oexc}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("tellerValidated.label")} ({report.numTellerPaid})
                      </td>
                      <td align="right">{report.tellerPaid}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        {" "}
                        {t("deductionFromOutstanding.label")} (
                        {report.numDeductOuts})
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.deductOutstanding}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>{t("currentOutBalance.label")}</strong>
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">
                        <strong>{report.curOutstanding}</strong>
                      </td>
                    </tr>
                  </table>
                  <div style={{ marginTop: 20, marginLeft: 20 }}>
                    <Typography variant="h6">
                      &nbsp;{t("accountSummary.label")}
                    </Typography>
                  </div>
                  <table className={classes.table2}>
                    <tr>
                      <td style={{ width: "400px" }}>
                        {t("currentAcctBalance.label")}
                      </td>
                      <td style={{ width: "300px" }}></td>
                      <td style={{ width: "160px" }}></td>
                      <td align="right" style={{ width: "160px" }}>
                        {report.curBalance}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("outstandingChecks.label")}</td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.curOutstanding}</td>
                    </tr>
                    <tr>
                      <td> {t("projectedAccount.label")}</td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.projBalance}</td>
                    </tr>
                  </table>
                </div>
              )}

            {this.state.canSearch &&
              this.state.totalCount !== 0 &&
              this.state.errorString.length === 0 &&
              this.state.notifyString.length === 0 &&
              this.state.selectedOption === "4" && (
                <div>
                  <div style={{ marginTop: 30, marginLeft: 20 }}>
                    <Typography variant="headline">
                      &nbsp;{t("accountReconci.label")}
                    </Typography>
                  </div>
                  <table className={classes.table1}>
                    <Paper elevation={6}>
                      <tr>
                        <td>
                          {" "}
                          <strong>&nbsp;{t("reportDate.label")}</strong>
                        </td>
                        <td> {report.dateCreated}</td>
                        <td colSpan={3}>
                          {" "}
                          <strong>&nbsp;{t("createdBy.label")}</strong>{" "}
                          &nbsp;&nbsp;&nbsp;{report.userName}
                        </td>
                      </tr>
                      <br />
                      <tr>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("companyName.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("transit.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("account.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;<strong>{t("from.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;<strong>{t("to.header")}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>&nbsp;&nbsp;&nbsp;{report.companyName}</td>
                        <td>
                          &nbsp;&nbsp;&nbsp;{this.props.accountObject.transit}
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;{this.props.accountObject.account}
                        </td>
                        <td>&nbsp;&nbsp;&nbsp;{report.startDate}</td>
                        <td>&nbsp;&nbsp;&nbsp;{report.endDate}</td>
                      </tr>
                    </Paper>
                  </table>
                  <div style={{ marginTop: 20, marginLeft: 20 }}>
                    <Typography variant="h6">
                      &nbsp;{t("checkingAcctSummary.label")}
                    </Typography>
                  </div>
                  <table className={classes.table2}>
                    <tr>
                      <td style={{ width: "400px" }}>
                        {t("balanceForward.label")}
                      </td>
                      <td style={{ width: "300px" }}></td>
                      <td style={{ width: "160px" }}></td>
                      <td align="right" style={{ width: "160px" }}>
                        {report.stBalance}
                      </td>
                    </tr>
                    <tr>
                      <td>
                        {t("addTotalCreditPeriod.label")} ({report.numCredits})
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.credits}</td>
                    </tr>
                    <tr>
                      <td>{t("deductTotal.label")}:</td>
                      <td>
                        {t("checkPaidPeriod.label")} ({report.numChkPaid1})
                      </td>
                      <td align="right">{report.chkPaid1}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("misDebits.label")} ({report.numMisDebits})
                      </td>
                      <td align="right">
                        <u>{report.misDebits}</u>
                      </td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        {t("totalDebitsPeriod.label")} ({report.numTotDebits})
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.totDebits}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>{t("currentBalance.label")}</strong>
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">
                        <strong>{report.curBalance}</strong>
                      </td>
                    </tr>
                  </table>
                  <div style={{ marginTop: 20, marginLeft: 20 }}>
                    <Typography variant="h6">
                      &nbsp;{t("accountReconciSummary.label")}
                    </Typography>
                  </div>
                  <table className={classes.table2}>
                    <tr>
                      <td style={{ width: "400px" }}>
                        {t("previousOutstanding.label")}
                      </td>
                      <td style={{ width: "300px" }}></td>
                      <td style={{ width: "160px" }}></td>
                      <td align="right" style={{ width: "160px" }}>
                        {report.preOutstanding}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("addTotal.label")}:</td>
                      <td>
                        {t("newIssue.label")} ({report.numNewIssue})
                      </td>
                      <td align="right">{report.newIssue}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("paidNotIssued.label")} ({report.numPni})
                      </td>
                      <td align="right">{report.pni}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("stopRemoved.label")} ({report.numStopRem})
                      </td>
                      <td align="right">{report.stopRem}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        {" "}
                        {t("additionsTo.label")} ({report.numAddOuts})
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.addOutstanding}</td>
                    </tr>
                    <tr>
                      <td> {t("deductTotal.label")}:</td>
                      <td>
                        {t("totalChkPaid.label")} ({report.numChkPaid2})
                      </td>
                      <td align="right">{report.chkPaid2}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("stopsPlaced.label")}({report.numStopPlace})
                      </td>
                      <td align="right">{report.stopPlace}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("issuesCancelled.label")} ({report.numCancelled})
                      </td>
                      <td align="right">{report.cancelled}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td></td>
                      <td>
                        {t("pniIssueReceived.label")}({report.numPrevPni})
                      </td>
                      <td align="right">{report.prevPni}</td>
                      <td></td>
                    </tr>
                    <tr>
                      <td>
                        {" "}
                        {t("deductionFromOutstanding.label")} (
                        {report.numDeductOuts})
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.deductOutstanding}</td>
                    </tr>
                    <tr>
                      <td>
                        <strong>{t("currentOutBalance.label")}</strong>
                      </td>
                      <td></td>
                      <td></td>
                      <td align="right">
                        <strong>{report.curOutstanding}</strong>
                      </td>
                    </tr>
                  </table>
                  <div style={{ marginTop: 20, marginLeft: 20 }}>
                    <Typography variant="h6">
                      &nbsp;{t("accountSummary.label")}
                    </Typography>
                  </div>
                  <table className={classes.table2}>
                    <tr>
                      <td style={{ width: "400px" }}>
                        {t("currentAcctBalance.label")}
                      </td>
                      <td style={{ width: "300px" }}></td>
                      <td style={{ width: "160px" }}></td>
                      <td align="right" style={{ width: "160px" }}>
                        {report.curBalance}
                      </td>
                    </tr>
                    <tr>
                      <td>{t("outstandingChecks.label")}</td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.curOutstanding}</td>
                    </tr>
                    <tr>
                      <td> {t("projectedAccount.label")}</td>
                      <td></td>
                      <td></td>
                      <td align="right">{report.projBalance}</td>
                    </tr>
                  </table>
                  {report.revisedDates && (
                    <table className={classes.table3}>
                      <tr>
                        <td style={{ fontSize: 10 }}>
                          * {t("reportDateRevised.label")}.{" "}
                        </td>
                      </tr>
                    </table>
                  )}
                </div>
              )}

            {this.state.canSearch &&
              this.state.totalCount !== 0 &&
              this.state.errorString.length === 0 &&
              this.state.notifyString.length === 0 &&
              this.state.selectedOption === "5" && (
                <div>
                  <div style={{ marginTop: 30, marginLeft: 20 }}>
                    <Typography variant="headline">
                      &nbsp;{t("accountReconciDetail.label")}
                    </Typography>
                  </div>
                  <table className={classes.table1}>
                    <Paper elevation={6}>
                      <tr>
                        <td>
                          {" "}
                          <strong>&nbsp;{t("reportDate.label")}</strong>
                        </td>
                        <td> {report.dateCreated}</td>
                        <td colSpan={3}>
                          {" "}
                          <strong>&nbsp;{t("createdBy.label")}</strong>{" "}
                          &nbsp;&nbsp;&nbsp;{report.userName}
                        </td>
                      </tr>
                      <br />
                      <tr>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("companyName.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("transit.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;
                          <strong>{t("account.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;<strong>{t("from.header")}</strong>
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;<strong>{t("to.header")}</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>&nbsp;&nbsp;&nbsp;{report.companyName}</td>
                        <td>
                          &nbsp;&nbsp;&nbsp;{this.props.accountObject.transit}
                        </td>
                        <td>
                          &nbsp;&nbsp;&nbsp;{this.props.accountObject.account}
                        </td>
                        <td>&nbsp;&nbsp;&nbsp;{report.startDate}</td>
                        <td>&nbsp;&nbsp;&nbsp;{report.endDate}</td>
                      </tr>
                    </Paper>
                  </table>
                  {this.state.radioValue !== "D" && (
                    <div>
                      <div style={{ marginTop: 20, marginLeft: 20 }}>
                        <Typography variant="h6">
                          &nbsp;{t("credits.label")}
                        </Typography>
                      </div>
                      <table className={classes.table}>
                        <TableHead>
                          <tr>
                            <td style={{ width: "100px" }}>
                              <strong>{t("date.header")}</strong>
                            </td>
                            <td style={{ width: "100px" }}>
                              <strong>{t("serial.header")}</strong>
                            </td>
                            <td style={{ width: "200px" }}>
                              <strong>{t("description.header")}</strong>
                            </td>
                            <td style={{ width: "120px" }}>
                              <strong>{t("deposits.header")}($)</strong>
                            </td>
                          </tr>
                        </TableHead>
                        <TableBody>
                          {items.map((item) => {
                            return (
                              <tr>
                                {item.type === "C" && <td>{item.itemDate} </td>}
                                {item.type === "C" && <td>{item.serial} </td>}
                                {item.type === "C" && (
                                  <td>{item.locationName} </td>
                                )}
                                {item.type === "C" && <td>{item.amount} </td>}
                              </tr>
                            );
                          })}
                          <tr style={{ height: "20px" }}></tr>
                          <tr>
                            <td colSpan={2}>
                              <strong>
                                {" "}
                                &nbsp;{t("items.label")}: {report.numCredits}{" "}
                              </strong>
                            </td>
                            <td colSpan={2}>
                              <strong>
                                {" "}
                                &nbsp;{t("amount.header")}:{" "}
                                {report.creditAmount}{" "}
                              </strong>
                            </td>
                          </tr>
                        </TableBody>
                      </table>
                    </div>
                  )}
                  {this.state.radioValue !== "C" && (
                    <div>
                      <div style={{ marginTop: 20, marginLeft: 20 }}>
                        <Typography variant="h6">
                          &nbsp;{t("debits.label")}
                        </Typography>
                      </div>
                      <table className={classes.table}>
                        <TableHead>
                          <tr>
                            <td style={{ width: "100px" }}>
                              <strong>{t("date.header")}</strong>
                            </td>
                            <td style={{ width: "100px" }}>
                              <strong>{t("serial.header")}</strong>
                            </td>
                            <td style={{ width: "200px" }}>
                              <strong>{t("description.header")}</strong>
                            </td>
                            <td style={{ width: "120px" }}>
                              <strong>{t("withdrawals.header")}($)</strong>
                            </td>
                          </tr>
                        </TableHead>
                        <TableBody>
                          {items.map((item) => {
                            return (
                              <tr>
                                {item.type === "D" && <td>{item.itemDate} </td>}
                                {item.type === "D" && <td>{item.serial} </td>}
                                {item.type === "D" && (
                                  <td>{item.locationName} </td>
                                )}
                                {item.type === "D" && <td>{item.amount} </td>}
                              </tr>
                            );
                          })}
                          <tr style={{ height: "20px" }}></tr>
                          <tr>
                            <td colSpan={2}>
                              <strong>
                                {" "}
                                &nbsp;{t("items.label")}: {report.numDebits}{" "}
                              </strong>
                            </td>
                            <td colSpan={2}>
                              <strong>
                                {" "}
                                &nbsp;{t("amount.header")}: {report.debitAmount}{" "}
                              </strong>
                            </td>
                          </tr>
                        </TableBody>
                      </table>
                    </div>
                  )}
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation()(withStyles(styles)(AccountReconciliationPage));
